// extracted by mini-css-extract-plugin
var _1 = "_YIOEWPVdqR1ui7Edvvl";
var _2 = "uJycCrdPM2fud4x0CZdb";
var _3 = "oww42PVeYaA8EmBOl8Wf";
var _4 = "QBSInBC46wDJHSSXCko_";
var _5 = "t98vn79HNSGirbgd2gOW";
var _6 = "YOATuRjSzwN5VM4y7bQQ";
var _7 = "hOwqefIR8LI80N1n1OrQ";
var _8 = "pgaoVr25S_TiTHX13eOW";
export { _1 as "bexley", _2 as "container", _3 as "eltham", _4 as "h1", _5 as "innerContainer", _6 as "letterBoard", _7 as "light", _8 as "withSpacing" }
